import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getAuthorizedDrivers } from '../../services/VehiclesService';
import { VehicleAuthorizedDrivers } from '../../types/Vehicles';
import { FeaturesManagement } from '../../../featuresControl';

function useGetAuthorizedDrivers(fleetId: string, vehicleId: string, query?: string): UseQueryResult<VehicleAuthorizedDrivers> {
  return useQuery(
    ['authorized-drivers', fleetId, vehicleId],
    async (): Promise<VehicleAuthorizedDrivers> => getAuthorizedDrivers(fleetId, vehicleId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
    },
  );
}

export default useGetAuthorizedDrivers;
